import React from 'react'

export default function MyClans() {
  
  return (
    <div className="no-found-box">
      <div className='no-found'>No clans found</div>
    </div>
  );
}